import { useParams } from "react-router-dom";
import { useQuery } from "@apollo/client";
import { gql } from "@/__generated__";
import Navbar from "@/components/layout/Navbar/Navbar";
import { ReferPatientProgressTracker } from "@/components/ReferPatientProgressTracker";
import { StrengthenReferral } from "../StrengthenReferral/StrengthenReferral";
import { DocumentsTab } from "../StrengthenReferral/components/tabs/DocumentsTab/DocumentsTab";

export const GET_APPEAL_STATUS = gql(`
  query GetAppealStatusForDocuments($appealId: ID!) {
    getAppealById(appealId: $appealId) {
      appealId
      status {
        referred
      }
    }
  }
`);

export function Documents() {
  const { appealId } = useParams<{ appealId: string }>();

  const { data } = useQuery(GET_APPEAL_STATUS, {
    variables: { appealId: appealId! },
    skip: !appealId,
    fetchPolicy: "no-cache",
  });

  const readOnly = data?.getAppealById?.status?.referred ?? false;

  if (!appealId) {
    return null;
  }

  return (
    <Navbar
      titleComponent={<ReferPatientProgressTracker appealId={appealId} />}
    >
      <StrengthenReferral
        appealId={appealId}
        activeTab="documents"
        tabContent={<DocumentsTab appealId={appealId} readOnly={readOnly} />}
      />
    </Navbar>
  );
}
